angular.module('igs.identity', ['igs.apiClientService'])
    .factory('igs.identityService', [
        '$q',
        '$window',
        'igs.apiClientService',
        '$location',
        function($q, $window, client, $location) {
            'use strict';
            var service = {};

            service.getCurrentUser = function() {
                // Check if we're on the login page - prevent redirect loop
                var currentHash = $window.location.hash || '';
                var currentPath = $location.path() || '';
                var isLoginPage = currentHash.toLowerCase().indexOf('/login') >= 0 ||
                                  currentPath.toLowerCase().indexOf('/login') >= 0;

                if (isLoginPage) {
                    // Return resolved promise with null user
                    return $q.resolve(null);
                }

                return client.getUnsecure('/api/identity/currentUser').then(function (data) {
                    if (data && data !== 'null') {
                        return data;
                    }
                    return null;
                });
            };

            service.goToLoginPage = function () {
                $window.location.href = '/';
            };

            return service;
        }
    ]);
